module.exports = __webpack_public_path__ + "img/topbg.f0367155.jpg";